import axios from 'axios';
import Storage from '@/utils/storage';
// import { generateJWT } from '@/utils';
const apiUrl = import.meta.env.VITE_API_URL;
const vtoken = import.meta.env.VITE_TOKEN;
const vuser = import.meta.env.VITE_USER;

const redirectTo = (url) => {
	window.location.href = url;
};

function httpService() {
	const service = axios.create();

	service.interceptors.request.use(
		function (config) {
			let token = Storage.get(vtoken);
			const lang = Storage.get('lang') || 'en';
			// Do something before request is sent
			let headers = config?.headers || {};
			headers['X-Locale'] = lang;
			if (config?.token) token = config?.token;
			if (token) headers['Authorization'] = 'Bearer ' + token;
			return {
				...config,
				baseURL: apiUrl,
				headers,
			};
		},
		function (error) {
			// Do something with request error
			return Promise.reject(error);
		}
	);

	service.interceptors.response.use(handleSuccess, handleError);

	function handleSuccess(response) {
		return response;
	}

	function handleError(error) {
		const status = error.response.status;
		switch (status) {
			case 400:
				// Not found
				console.log('Bad Request');
				// redirectTo('/400');
				break;
			case 403:
				// Unauthorized
				// Token expired
				window.localStorage.removeItem(vtoken);
				window.localStorage.removeItem(vuser);
				redirectTo(`/login`);
				console.log('Token expired');
				break;
			case 404:
				// Not found
				console.log('Not found');
				// redirectTo('/404');
				break;
			default:
				// Internal server error
				console.log('Internal server error');
				// redirectTo('/500');
				break;
		}

		// FIXME: custom error 500
		const response =
			status === 500
				? {
						data: {
							errors: {
								code: 'Internal server error',
							},
						},
				  }
				: error.response;

		return { status, ...response };
	}

	return {
		get: (...args) => service.get(...args),
		post: (...args) => service.post(...args),
		put: (...args) => service.put(...args),
		patch: (...args) => service.patch(...args),
		delete: (...args) => service.delete(...args),
	};
}

export default httpService();
